import React from 'react';
import classnames from 'classnames';
import { useRouteMatch } from 'react-router-dom';

import { SearchDown, TickerNav, Button } from 'components';
import { NiraLogo, SearchBar, UserNav } from 'components/shared/NavigationBar';
import Icon from 'assets/icons';

import { chromeInstallUrl, inImpersonateMode } from 'helpers/constants';
import { isExtensionInstalled } from 'helpers/extension';

import { useSidebarDispatch } from 'context';

import styles from './NavigationBar.module.scss';

import { ImpersonateModeLogo } from 'screens/ImpersonateScreen';

export const NavigationBar = () => {
  const sidebarDispatch = useSidebarDispatch();

  /*
   * TODO
   * Extract logic for hiding sidebar
   */

  const isSettingsRoute = useRouteMatch({
    path: '/settings',
    exact: true,
    strict: true,
    sensitive: true,
  });

  const isProfileRoute = useRouteMatch({
    path: '/profile',
    exact: false,
    strict: false,
    sensitive: true,
  });

  const isGroupRoute = useRouteMatch({
    path: '/group',
    exact: false,
    strict: false,
    sensitive: true,
  });

  const showTickerNav = !isSettingsRoute && !isProfileRoute && !isGroupRoute;

  const openSidebar = React.useCallback(() => {
    sidebarDispatch({ type: 'OPEN_SIDEBAR' });
  }, [sidebarDispatch]);

  return (
    <>
      <header className={styles.container}>
        <div className={styles.outerBin}>
          <div className={styles.bin}>
            {!isSettingsRoute && (
              <span
                className={classnames('hasTooltip tooltipBelowLeft', styles.appsTrigger)}
                data-tooltip="Apps"
                onClick={openSidebar}
              >
                <Icon.Menu />
              </span>
            )}

            <SearchDown />

            {/* 1. NIRA LOGO */}
            {inImpersonateMode ? <ImpersonateModeLogo isNira /> : <NiraLogo />}

            {/* 2. SEARCH BAR */}
            <div className={styles.searchBarWrapper} key="searchBar" data-tid="header-search">
              <SearchBar size="Small" />

              {/* 2a. ADD TO CHROME BUTTON */}
              {isExtensionInstalled === false && !inImpersonateMode && (
                <Button
                  onClick={() => window.open(chromeInstallUrl)}
                  type="Special"
                  className={styles.downloadChrome}
                >
                  <Icon.Plus className={styles.icon} /> Add to Chrome
                </Button>
              )}

              {inImpersonateMode && (
                <div className={styles.impersonationPill}>Impersonation Mode</div>
              )}
            </div>

            {/* 3.PROFILE, CREATE, SETTINGS  */}
            <div className={styles.nav} key="userNav">
              <UserNav onlyDisplayLogout={undefined} />
            </div>
          </div>
        </div>
      </header>
      {showTickerNav && <TickerNav />}
    </>
  );
};
